module.exports = __webpack_public_path__ + "static/img/yue_zhang_2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/yue_zhang_2.jpg
// module id = M733
// module chunks = 0